export function isPast(date) {
	return new Date().getTime() - new Date(date).getTime() > 0;
}

export function toLocaleDate(date) {
	return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
}
